<template>
  <div class="login-container" style="background:#fff;">        
        <div class="sticky-header">
        <p class="over-heard-title">
          <img :style="clientWidth>1200?'':'width: 4rem;object-fit: cover;'"  @click="goRoute" src="../../assets/img/aixueji1.png" alt="" />  
        </p> 
         
      </div> 
      <div class="a-tiyan-Box">
        <div class="a-yiyan-title">
          <img class="trial" src="../../assets/img/tiyan@2.png" alt="" /> 
        </div>

        <div>
          <h3 style="color: #0E0806;font-size: 23px;margin-top: 48px;">免费体验</h3>
          <!-- <p class="mytag" style="color: #232533;font-size: 14px;letter-spacing: 0px;">在免费体验之前您可以先联系我们服务中心,咨询期间不收取任何费用</p> -->
        </div>
         <div class="trial-center">
         联系我们开通试用
        </div>  

         <div class="contact-we-tab">
          <div class="contact-we-line">
             <img :style="clientWidth>1200?'':'width: 4rem;object-fit: cover;'"  src="../../assets/img/trial@1.png" alt="" />  
            <div class="contact-we-line-message">
              <p>商务合作</p>
              <p>
                <a  class="calltel" href="tel:18130031564">叶老师:18130031564</a>
              </p>
            </div>
          </div>                
        </div>
        <div class="contact-we-tab">
          <div class="contact-we-line">
             <img :style="clientWidth>1200?'':'width: 4rem;object-fit: cover;'"  src="../../assets/img/trial@2.png" alt="" />  
            <div class="contact-we-line-message">
              <p>技术保障</p>
              <p>
                <a class="calltel" href="tel:15855174321">胡老师:15855174321</a>
              </p>
            </div>
          </div>                
        </div>
        <div class="contact-we-tab">
          <div class="contact-we-line">
             <img :style="clientWidth>1200?'':'width: 4rem;object-fit: cover;'"  src="../../assets/img/trial@3.png" alt="" />  
            <div class="contact-we-line-message">
              <p>售后处理</p>
              <p>
                <a class="calltel" href="tel:18158850584">李老师:18158850584</a>
              </p>
            </div>
          </div>                
        </div>
        <div class="contact-we-tab">
          <div class="contact-we-line">
             <img :style="clientWidth>1200?'':'width: 4rem;object-fit: cover;'"  src="../../assets/img/trial@4.png" alt="" />  
            <div class="contact-we-line-message">
              <p>高校咨询</p>
              <p>
                <a class="calltel"  href="tel:15256510561">汪老师:15256510561</a>
              </p>
            </div>
          </div>                
        </div>




       
        </div>  
          <div class="trail-bottom">
     <span>Copyright © 安徽爱学记信息科技有限公司版权所有<br />备案号:皖ICP备19022735号-1</span>
   </div> 
           
  </div>
</template>
<script>
export default {
  name: 'Login',
  data() {
    return {
     clientWidth:"",
    }
  },
  mounted(){
     this.clientWidth=document.body.clientWidth
  },
  methods: {
    goRoute(){
       this.$router.push('/');
    }   

     
  }
    
}
</script>
<style lang="scss">
.calltel{
 font-weight: 500;
    text-align: left;
    color: #504F5B;
    font-size: 15px;
    line-height: 10px;
    text-decoration:none;
    cursor: pointer;
}
  @media (max-width:1200px){ 
    .mytag{
      padding: 0 3rem;
    }
    .sticky-header{
      height:52px;
    }
.a-tiyan-Box {
    -webkit-animation: fadeInUp ease 1s;
    animation: fadeInUp ease 1s;
    -webkit-animation-iteration-count: 1;
    animation-iteration-count: 1;
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;  
    height: 550px;
    position: relative;
    top: 60px;
    margin: 0 auto;
    background: #FFFFFF;
    margin: 0 auto;
    background: url(/static/img/tiyan@1.5dc486f6.png) 0 0 no-repeat;
    background-size: 100% 100%;
   box-shadow: 0px 12px 40px 0px rgba(182, 177, 178, 0.3);
}
 .over-heard{
        display: flex;
         width: 100%;    
        height: 69px;
        align-items: center;
        justify-content: space-between;
        position: absolute;
        top: 0;
        &-title{          
         position: absolute;
    top: 0;
    left: 23px;
        }
   }
    }

  @media (min-width:1200px){ 
    .sticky-header{
      height:69px;
    }
  .a-tiyan-Box{
    animation: fadeInUp ease 1s;
    animation-iteration-count: 1; /*设置动画播放次数*/
    animation-fill-mode: forwards; 
    width: 470px;
    height:550px;
    position: relative;
    top:100px;
    margin: 0 auto;
    background: #FFFFFF;
    margin: 0 auto;
     background: url(../../assets/img/tiyan@1.png) 0 0 no-repeat;
     background-size:100% 100%;
    box-shadow: 0px 12px 40px 0px rgba(182, 177, 178, 0.3);
    }
  .over-heard{
        display: flex;
         width: 100%;    
        height: 69px;
        align-items: center;
        justify-content: space-between;
        position: absolute;
        top: 0;
        &-title{          
          margin-left:14vw;
          cursor: pointer;
        }
   }
    }


@keyframes fadeInAnimation {
0% {
opacity: 0; /*设置不透明度*/

}
100% {
opacity: 1;
}
}
@keyframes fadeInUp {
0% {
transform:translateY(70px);  
}
100% {
transform:translateY(0);  
 
}
}
 .sticky-header {
    position: fixed;
    // opacity: 0;
    // visibility: hidden;
    border-bottom:0;
    box-shadow: 0px 0px 29px 0px rgba(170, 168, 163, 0.25);
    left: 0px;
    top: 0px;
    width: 100%;
    padding: 0px 0px;
    background: #ffffff;
    // z-index: 0;
    border-bottom: 1px solid #e8f1f7;
    transition: all 500ms ease;
    -moz-transition: all 500ms ease;
    -webkit-transition: all 500ms ease;
    -ms-transition: all 500ms ease;
    -o-transition: all 500ms ease;
}
 .sticky-header {
    z-index: 999;
    opacity: 1;   
     display: flex;
    align-items: center;
    visibility: visible;
    justify-content:space-between;
    -ms-animation-name: fadeInAnimation;
    -moz-animation-name: fadeInAnimation;
    -op-animation-name: fadeInAnimation;
    -webkit-animation-name: fadeInAnimation;
    animation-name: fadeInAnimation;
    -ms-animation-duration: 500ms;
    -moz-animation-duration: 500ms;
    -op-animation-duration: 500ms;
    -webkit-animation-duration: 500ms;
    animation-duration: 500ms;
    -ms-animation-timing-function: linear;
    -moz-animation-timing-function: linear;
    -op-animation-timing-function: linear;
    -webkit-animation-timing-function: linear;
    animation-timing-function: linear;
    -ms-animation-iteration-count: 1;
    -moz-animation-iteration-count: 1;
    -op-animation-iteration-count: 1;
    -webkit-animation-iteration-count: 1;
    animation-iteration-count: 1;
}
 

    .trial{
    position: relative;
    top: 68px;
    width: 200px;
    }
    .trial-center{
      width: 340px;
      height: 40px;
      background: #ffebe5;
      font-size: 16px;     
      color: #F86740;
      margin:0 auto;
      line-height: 40px;
    }
   .contact-we-tab{
      display:flex;
      justify-content:center;
      align-items:center;   
      height:79px;  
    }
     .contact-we-line{
      margin-right:2em;
      display:flex;
      align-items:center;
      img{
        margin-right:10px;
      }
    
    }
      .contact-we-line-message{
        font-weight: 500;
        text-align:left;
        color:#504F5B;
        font-size:15px;
        line-height:10px;
        cursor: pointer;
      }
       .trail-bottom{
       color: #BAB7BD;
    font-size: 12px;
    width: 100%;
    text-align: center;
    position: fixed;
    bottom: 10px;
     }
</style>
